module.exports = __webpack_public_path__ + "img/02_cg.e195ace6.png";